define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/state",
	"csi/table/SwitchboardWidget",
	"csi/xml"
], function(declare, reflection, state, SwitchboardWidget, xml) {

	return declare(SwitchboardWidget, {
		onSwitchView: function(/*csi.view.Widget*/view) {
			// summary: overwrite onClick handler for images
			if (!state.get("print")) {
				view.watch("customViewId", (attr, oldValue, newValue) => {
					// update selected export definition to reference new view
					var node = this.getSwitchboardSelectedNode();
					if (node.View != newValue) {
						this.writeOperations((writer) => {
							writer.changeNode(node.$URL).changeAttribute("View", xml.ATTR_REF, newValue);

							// use this rather than redrawNode so query is not sent to server that will get
							// old value rather than the new value
							this.refreshDataRows(tr => this.getRefNodeUrl(tr) == node.$URL);
						}, true);
					}
				});
			}
		},

		_onViewPreferences: function(/*PreferenceView*/item) {
		},

		_postActionEdit: function(/*Controller*/ac) {
			// summary: update viewLayout when definition edited if editing selected node
			if (ac.m_urlNode == this.getSwitchboardSelectedNode().$URL) {
				const self = this;
				const view = this.viewLayout;
				const node = ac.getNode();
				const type = view.relRoot.m_typeNode;
				const rc = reflection.getClass(node.ClassName);

				setTimeout(function() {
					if (type == rc.getType()) {
						// if class stayed same, then just switch custom view
						view.urlDefaultView = node.View;
						view.refreshDefaultCustomView();
					} else {
						// if class changed, then refresh layout view
						self._deleteViewLayout();

						self.defView.m_formData.resetSelections();
						self.defView.m_formData.changeSelection(self.getContext(node.$URL), true);
					}
				}, 1);
			}
		},

		_switchSelect: function(/*Node*/node) {
			// summary: remove view so that it will be recreated with the new node
			this._deleteViewLayout();
			return this.inherited(arguments);
		}
	});
});